module.exports = __webpack_public_path__ + "static/media/catalog_brand.2686f389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/catalog_brand.png
// module id = 586
// module chunks = 2